export const COMPANY_LOAD_REQUEST = "COMPANY_LOAD_REQUEST";
export const COMPANY_LOAD_SUCCESS = "COMPANY_LOAD_SUCCESS";
export const COMPANY_LOAD_FAIL = "COMPANY_LOAD_FAIL";
export const COMPANY_LOAD_RESET = "COMPANY_LOAD_RESET";

export const COMPANY_LOAD_SINGLE_REQUEST = "COMPANY_LOAD_SINGLE_REQUEST";
export const COMPANY_LOAD_SINGLE_SUCCESS = "COMPANY_LOAD_SINGLE_SUCCESS";
export const COMPANY_LOAD_SINGLE_FAIL = "COMPANY_LOAD_SINGLE_FAIL";
export const COMPANY_LOAD_SINGLE_RESET = "COMPANY_LOAD_SINGLE_RESET";

export const COMPANY_CREATE_LOAD = "COMPANY_CREATE_LOAD";
export const COMPANY_CREATE_REQUEST = "COMPANY_CREATE_REQUEST";
export const COMPANY_CREATE_SUCCESS = "COMPANY_CREATE_SUCCESS";
export const COMPANY_CREATE_FAIL = "COMPANY_CREATE_FAIL";